// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import {img_url} from './img_url';
import cn from 'classnames';
import styles from './map_with_pins.module.less';
import '/www/hola/pub/css/wbm_flags.less';

export type t_map_type = 'classic'|'flat';

interface i_pin {
    c: string;
    x: number;
    y: number;
    scale?: number;
}

const map_info = {
    'classic': {
        background: 'homepage/globe.png',
        default_pins: [
            {c: 'co', x: 27.5, y: 51.0},
            {c: 'pl', x: 62.5, y: 26.8},
            {c: 'za', x: 63.5, y: 66.3},
            {c: 'ar', x: 34.6, y: 70.7},
            {c: 'es', x: 53.2, y: 34.0},
            {c: 'uk', x: 51.0, y: 26.1},
            {c: 'dz', x: 57.6, y: 37.4},
            {c: 'ru', x: 67.2, y: 24.7},
            {c: 'us', x: 24.4, y: 37.6},
            {c: 'de', x: 58.4, y: 28.0},
            {c: 'it', x: 59.6, y: 30.9},
            {c: 'by', x: 57.6, y: 23.9},
            {c: 'br', x: 40.1, y: 59.4},
            {c: 'ca', x: 30.1, y: 31.9},
            {c: 'ca', x: 25.8, y: 30.3},
            {c: 'mx', x: 19.8, y: 47.3},
            {c: 'il', x: 65.7, y: 34.0},
            {c: 'fr', x: 55.6, y: 31.3},
            {c: 'us', x: 18.2, y: 38.4},
            {c: 'us', x: 15, y: 31},
            {c: 'nl', x: 54.2, y: 21.1},
            {c: 'pe', x: 25.6, y: 60.7},
        ]
    },
    'flat': {
        background: 'download/earth_map.svg',
        default_pins: [
          {c: 'us', x: 18, y: 30, scale: 1.8},
          {c: 'us', x: 6, y: 41, scale: 1.2},
          {c: 'ag', x: 21, y: 54, scale: 1.3},
          {c: 'ao', x: 78, y: 66, scale: 1.57},
          {c: 'dz', x: 62, y: 51, scale: 1.34},
          {c: 'gb', x: 55, y: 24, scale: 1.72},
          {c: 'fr', x: 68, y: 30, scale: 0.95},
          {c: 'af', x: 92, y: 43, scale: 1.55},
          {c: 'al', x: 82, y: 25, scale: 1.05},
          {c: 'as', x: 11, y: 76, scale: 1.4},
        ]
    }
};

interface i_map_with_pins_props {
    type: t_map_type;
    pins?: i_pin[];
    cls?: string;
    scrolled: boolean;
}

export const Map_with_pins = ({type, pins, cls, scrolled}
    :i_map_with_pins_props)=>{
    const info = map_info[type];
    if (!pins)
        pins = info.default_pins;
    return <div className={cn(styles.root, cls)}>
      <div className={cn(styles.container, scrolled && styles.scrolled)}>
        <img className={cn('lazyload', styles.globe)} alt="info"
          data-src={img_url(info.background)}/>
        {pins.map(({c, x, y, scale=1}, i)=>{
            return <div key={i} style={{position: 'absolute' as const,
              top: y+'%', left: x+'%',
              transformOrigin: 'bottom center', zIndex: i,
              transform: `translate(-50%, -100%) scale(${scale})`}}>
              <div className={styles.pin}
                style={{animationDelay: `${500+100*i}ms`}}>
                <div className={cn(styles.flag, 'f32')}>
                  <i className={cn('flag', c)}></i>
                </div>
              </div>
            </div>;
        })}
      </div>
    </div>;
};
